/*
 * @Description:地图通用组件
 * @Version: 1.0
 * @Autor: zsw
 * @Date: 2021-09-14 09:32:57
 * @LastEditors: zsw
 * @LastEditTime: 2021-09-15 14:32:02
 */
import {
  TileSuperMapRest
}
from '@supermap/iclient-ol';
import {
  XYZ
}
from 'ol/source';
import Vector from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {
  Tile as TileLayer
} from 'ol/layer';
import axios from 'axios';
import GeoJSON from 'ol/format/GeoJSON';
import {
  Fill,
  Stroke,
  Style
} from 'ol/style';
export const guandaoLayer = (url) => {
  return new TileLayer({
    source: new TileSuperMapRest({
      url,
      prjCoordSys: {
        epsgCode: 4326
      },
      clipRegionEnabled: true,
      tileversion: 'v1.0',
      transparent: true
    }),
    isGroup: true,
    useInterimTilesOnError: true,
    name: '管道图'
  })
}
export function tmapImage() {
  return new TileLayer({
    source: new XYZ({
      // url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scl=2&style=6'
      url: 'https://t{0-7}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TileCol={x}&TileRow={y}&TileMatrix={z}&tk=1d109683f4d84198e37a38c442d68311'
    }),
    isGroup: true,
    name: '天地图路网'
  })
}
export function tmapText() {
  return new TileLayer({
    source: new XYZ({
      url: 'https://t0.tianditu.gov.cn/DataServer?T=cia_w&x={x}&y={y}&l={z}&tk=1d109683f4d84198e37a38c442d68311'
    }),
    isGroup: true,
    name: '天地图文字标注'
  })
}
export function iclientImage(url) {
  return new TileLayer({
    source: new TileSuperMapRest({
      url,
      cacheEnabled: true
    }),
    isGroup: true,
    name: '高清影像图'
  })
}
export function boundaryLayer(url) {
  return new Vector({
    source: new VectorSource({
      url,
      loader: function(extent, resolution, projection) {
        axios({
          url: url,
          method: 'get'
        }).then((res) => {
          this.addFeatures(this.getFormat().readFeatures(res.data));
        });
      },
      format: new GeoJSON(),
      projection: 'EPSG:4326'
    }),
    style: new Style({
      fill: new Fill({
        color: 'RGBA(97, 155, 162, 0)'
      }),
      stroke: new Stroke({
        color: 'RGBA(15, 246, 238, 1)',
        width: 2
      })
    })
  })
}
